import React from "react";
import ride1 from "../../../assets/newImg/ride7.jpg";
import ride2 from "../../../assets/newImg/ride6.jpg";
import ride3 from "../../../assets/newImg/ride8.jpg";
import ride4 from "../../../assets/newImg/ride5.jpg";
import ride5 from "../../../assets/newImg/ride4.jpg";
import ride6 from "../../../assets/newImg/ride3.jpg";
import ride7 from "../../../assets/newImg/ride2.jpg";
import ride8 from "../../../assets/newImg/ride1.jpg";
import ride1r from "../../../assets/newImg/ride1r.jpg";
import ride2r from "../../../assets/newImg/ride2r.jpg";
import ride3r from "../../../assets/newImg/ride3r.jpg";
import ride4r from "../../../assets/newImg/ride4r.jpg";
import ride5r from "../../../assets/newImg/ride5r.jpg";
import ride6r from "../../../assets/newImg/ride6r.jpg";
import ride7r from "../../../assets/newImg/ride7r.jpg";
import ride8r from "../../../assets/newImg/ride8r.jpg";
import Step from "./Step";
import cookies from "js-cookie";

import { useTranslation } from "react-i18next";
const Steps = () => {
  const { t } = useTranslation();
  const titles = t("ridePage.steps", { returnObjects: true });
  const lng = cookies.get("i18next") || "en";

  const images =
    lng === "ar"
      ? [ride1r, ride2r, ride3r, ride4r, ride5r, ride6r, ride7r, ride8r]
      : [ride1, ride2, ride3, ride4, ride5, ride6, ride7, ride8];

  const steps = titles.map((title, index) => ({
    id: index + 1,
    img: images[index],
    title: title,
  }));
  return (
    <div className=" flex flex-col pb-5">
      {steps?.map((item) => (
        <Step key={item?.id} item={item} />
      ))}
    </div>
  );
};

export default Steps;
